import {useContext} from 'react';
import {useStateMachine} from 'little-state-machine';
import clearForms from 'components/forms/reducers/clearForms';
import getClearForm from 'components/forms/reducers/clearForm';
import {FormState} from 'components/forms/context';

export function useClearForm(nodeOverride) {
    const {node} = useContext(FormState);
    const {actions, state} = useStateMachine({update: getClearForm(nodeOverride || node)});

    return () => {
        Object.keys(state).length && actions.update({});
    };
}

/**
 * Provide access to the state of the FormStateNode context form
 */
export function useClearForms() {
    const {actions, state} = useStateMachine({update: clearForms});

    return () => {
        Object.keys(state).length && actions.update({});
    };
}
